import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { videoModalStyles } from './styles';
import ReactModal from 'react-modal';
/*

    Receives props from parent:
    - isOpen
    - onClose

*/

export class VideoModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            showModal: props.show,
            styles: videoModalStyles
        }
    }

    componentDidMount() {
        this.setState({
            showModal: this.props.show
        })
       
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        // set opacity back to 1??
    }
    
    render(){
        const { styles } = this.state; 
        return (
            <div>
                <ReactModal
                    isOpen={this.props.isOpen}
                    onRequestClose={this.props.onClose}
                    style={{ content: {...styles.modalContent}, overlay: {...styles.modalOverlay} }}
                >
                    {this.props.children}
                    
                    <button
                        style={styles.closeButtonStyle}
                        onClick={this.props.onClose}
                    >
                        <span style={styles.closeButtonTextStyle}> CLOSE</span>
                        <i className="fa fa-times-circle fa-inverse"></i>
                    </button>
                </ReactModal>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/js/components/VideoModal/VideoModal.jsx